<template>
  <div>
    <div class="ui card" @click.stop="$emit('click')">
      <div class="image">      
        <img class="lazyload" :data-src="hqThumbnail">
      </div>    
      <div class="content">
        <div class="header" v-html="title"></div>
        <div class="meta">
          <span class="date">{{createdDate}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'lazysizes';
import moment from 'moment';

export default {
  props: ['thumbnail', 'title', 'created'],
  data () {
    return {
      loaded: false,
    };
  },
  mounted() {
    moment.locale(navigator.language);
  },
  computed: {
    createdDate () {
      const offset = Date.now() - this.created;
      if (offset >= 2 * 24 * 60 * 60 * 1000) {
        return moment(this.created).format('MMMM D [at] h:mma');
      } else {
        return moment(this.created).fromNow();
      }
    },
    hqThumbnail () {
      let matches = /https?:\/\/img.youtube.com\/vi\/(.*)\//.exec(this.thumbnail);
      let videoId = matches && matches[1];
      if (videoId) {
        return `http://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
      } else {
        return this.thumbnail;
      }
    },
  },
}
</script>

<style>
.lazyload,
.lazyloading {
  position: static;
  animation: placeholderShimmer 2s linear;
  animation-iteration-count: infinite;
  background-image: linear-gradient(to right,rgba(0,0,0,.08) 0,rgba(0,0,0,.15) 15%,rgba(0,0,0,.08) 30%);
  background-size: 1200px 100%;
  max-width: 30rem;
  overflow: hidden;
  padding-top: 75%;
}
</style>
